// // components/JobList.jsx
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// export default function JobList() {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}admin`);
//         setJobs(res.data);
//       } catch (err) {
//         console.log(err)
//         setError('Failed to load jobs');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobs();
//   }, []);

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-indigo-600"></div>
//       </div>
//     );
//   }

//   // if (error) {
//   //   return <p className="text-center text-red-600 font-medium">{error}</p>;
//   // }

//   return (
//     <div className="max-w-6xl mx-auto p-6">
//       <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">Latest Job Openings</h1>

//       {jobs.length === 0 ? (
//         <p className="text-center text-gray-500">No jobs posted yet.</p>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {jobs.map((job) => (
//             <div
//               key={job._id}
//               className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden"
//             >
//               {job.imageUrl ? (
//                 <img
//                   src={job.imageUrl}
//                   alt={job.title || 'Job'}
//                   className="w-full h-48 object-cover"
//                 />
//               ) : (
//                 <div className="bg-gradient-to-br from-indigo-500 to-purple-600 h-48 flex items-center justify-center">
//                   <span className="text-white text-2xl font-bold">{job.companyName?.[0]}</span>
//                 </div>
//               )}

//               <div className="p-5">
//                 {job.title && (
//                   <h3 className="text-xl font-semibold text-gray-800 mb-2">{job.title}</h3>
//                 )}
//                 <p className="text-indigo-600 font-medium mb-1">{job.companyName}</p>

//                 {job.salary && (
//                   <p className="text-sm text-green-600 font-semibold mb-2">{job.salary}</p>
//                 )}

//                 {job.address && (
//                   <p className="text-sm text-gray-600 flex items-center mb-3">
//                     <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
//                       <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
//                     </svg>
//                     {job.address}
//                   </p>
//                 )}

//                 {job.writeUp && !job.title && (
//                   <div
//                     className="text-sm text-gray-700 line-clamp-3"
//                     dangerouslySetInnerHTML={{ __html: job.writeUp.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}
//                   />
//                 )}

//                 <div className="mt-4 flex justify-between text-xs text-gray-500">
//                   <span>Contact: {job.email || job.contactNumber}</span>
//                   <span>Contact: {job.contactNumber || job.email}</span>
//                   <span>{new Date(job.createdAt).toLocaleDateString()}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }




/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function JobList() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedJob, setSelectedJob] = useState(null);

  const jobsPerPage = 6;

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_API_URL}admin`);
        setJobs(res.data);
      } catch (err) {
        console.log(err);
        setError('Failed to load jobs');
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  // Calculate pagination
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(jobs.length / jobsPerPage);

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const openJobModal = (job) => {
    setSelectedJob(job);
  };

  const closeModal = () => {
    setSelectedJob(null);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Latest Job Openings</h1>

      {jobs.length === 0 ? (
        <p className="text-center text-gray-500 text-lg">No jobs posted yet.</p>
      ) : (
        <>
          {/* Job Grid - 6 per page */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentJobs.map((job) => (
              <div
                key={job._id}
                onClick={() => openJobModal(job)}
                className="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer overflow-hidden transform hover:-translate-y-2"
              >
                {job.imageUrl ? (
                  <img
                    src={job.imageUrl}
                    alt={job.title || job.companyName}
                    className="w-full h-52 object-cover"
                  />
                ) : (
                  <div className="bg-gradient-to-br from-indigo-500 to-purple-600 h-52 flex items-center justify-center">
                    <span className="text-white text-4xl font-bold">
                      {job.companyName?.charAt(0).toUpperCase() || 'J'}
                    </span>
                  </div>
                )}

                <div className="p-6">
                  {job.title ? (
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{job.title}</h3>
                  ) : (
                    <h3 className="text-xl font-bold text-gray-800 mb-2">Job Opportunity</h3>
                  )}
                  <p className="text-indigo-600 font-semibold text-lg mb-2">{job.companyName}</p>

                  {job.salary && (
                    <p className="text-green-600 font-medium mb-3">{job.salary}</p>
                  )}
                  { job.requirements && (
                    <span className='text-1xl font-bold'> Requirements:
  <p className="text-green-600 font-medium mb-3">{job.requirements}</p>
                    </span>
                  
                  )}

                  {job.address && (
                    <p className="text-gray-600 text-sm flex items-center mb-3">
                      <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
                      </svg>
                      {job.address}
                    </p>
                  )}

                  <div className="text-xs text-gray-500 flex justify-between mt-4">
                    <span>{job.email || job.contactNumber || 'Contact via details'}</span>
                    <span>{new Date(job.createdAt).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="flex justify-center items-center gap-6 mt-12">
              <button
                onClick={goToPrevPage}
                disabled={currentPage === 1}
                className={`px-6 py-3 rounded-xl font-medium transition-all ${
                  currentPage === 1
                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                    : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg'
                }`}
              >
                ← Previous
              </button>

              <span className="text-lg font-medium text-gray-700">
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={goToNextPage}
                disabled={currentPage === totalPages}
                className={`px-6 py-3 rounded-xl font-medium transition-all ${
                  currentPage === totalPages
                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                    : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg'
                }`}
              >
                Next →
              </button>
            </div>
          )}
        </>
      )}

      {/* Job Detail Modal */}
      {selectedJob && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {selectedJob.imageUrl ? (
              <img
                src={selectedJob.imageUrl}
                alt={selectedJob.title || selectedJob.companyName}
                className="w-full h-64 object-cover rounded-t-2xl"
              />
            ) : (
              <div className="bg-gradient-to-br from-indigo-500 to-purple-600 h-64 flex items-center justify-center rounded-t-2xl">
                <span className="text-white text-6xl font-bold">
                  {selectedJob.companyName?.charAt(0).toUpperCase() || 'J'}
                </span>
              </div>
            )}

            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-2">
                    {selectedJob.title || 'Job Opportunity'}
                  </h2>
                  <p className="text-2xl font-semibold text-indigo-600">
                    {selectedJob.companyName}
                  </p>
                </div>
                <button
                  onClick={closeModal}
                  className="text-gray-500 hover:text-gray-700 text-3xl"
                >
                  ×
                </button>
              </div>

              {selectedJob.salary && (
                <div className="mb-6">
                  <span className="text-green-600 text-2xl font-bold">{selectedJob.salary}</span>
                </div>
              )}

              {selectedJob.address && (
                <p className="text-gray-700 flex items-center gap-2 mb-6">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
                  </svg>
                  <span className="text-lg">{selectedJob.address}</span>
                
                </p>
              )}
              {selectedJob.requirements && (
                <p className="text-gray-700 flex items-center gap-2 mb-6">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
                  </svg>
                  <span className="text-lg">{selectedJob.requirements}</span>
                
                </p>
              )}

              {/* Full Description */}
              {(selectedJob.writeUp || selectedJob.description) && (
                <div className="mb-8">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Job Description</h3>
                  <div
                    className="text-gray-700 leading-relaxed text-base prose prose-lg max-w-none"
                    dangerouslySetInnerHTML={{
                      __html: (selectedJob.writeUp || selectedJob.description || '')
                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                        .replace(/\n/g, '<br />'),
                    }}
                  />
                </div>
              )}

              {/* Contact Info */}
              <div className="border-t pt-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4">How to Apply</h3>
                <div className="space-y-3 text-lg">
                  {selectedJob.email && (
                    <p>
                      <strong>Email:</strong>{' '}
                      <a href={`mailto:${selectedJob.email}`} className="text-indigo-600 hover:underline">
                        {selectedJob.email}
                      </a>
                    </p>
                  )}
                  {selectedJob.contactNumber && (
                    <p>
                      <strong>Phone:</strong>{' '}
                      <a href={`tel:${selectedJob.contactNumber}`} className="text-indigo-600 hover:underline">
                        {selectedJob.contactNumber}
                      </a>
                    </p>
                  )}
                  <p className="text-sm text-gray-500 mt-4">
                    Posted on: {new Date(selectedJob.createdAt).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </p>
                </div>
              </div>

              <button
                onClick={closeModal}
                className="mt-8 w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 rounded-xl transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}